import { api } from './api';

export interface Caja {
  id: number;
  sucursalId: number;
  name: string;
  numeroCaja: number;
  isActive: boolean;
  sucursal?: {
    id: number;
    name: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface CajaCreate {
  sucursalId: number;
  name: string;
  numeroCaja: number;
}

export interface CajaUpdate {
  name?: string;
  numeroCaja?: number;
  isActive?: boolean;
}

export interface PaginatedResponse<T> {
  data: {
    [key: string]: T[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const cajaService = {
  getAll: async (page = 1, limit = 10, sucursalId?: number): Promise<PaginatedResponse<Caja>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    if (sucursalId) params.append('sucursalId', sucursalId.toString());
    
    const response = await api.get<PaginatedResponse<Caja>>(`/cajas?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { caja: Caja } }> => {
    const response = await api.get<{ data: { caja: Caja } }>(`/cajas/${id}`);
    return response.data;
  },

  create: async (data: CajaCreate): Promise<{ data: { caja: Caja } }> => {
    const response = await api.post<{ data: { caja: Caja } }>('/cajas', data);
    return response.data;
  },

  update: async (id: number, data: CajaUpdate): Promise<{ data: { caja: Caja } }> => {
    const response = await api.put<{ data: { caja: Caja } }>(`/cajas/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/cajas/${id}`);
  }
};

